import React, { Component, useEffect } from 'react';

import withAuthServerSideProps from '@/libs/auth';

import { PageLayout } from '@/layouts/shared';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { isIOS, isAndroid } from 'react-device-detect';

const DownloadPage = () => {
  const router = useRouter();
  let url = process.env.APP_URL || '';
  if (isIOS && process.env.APPLE_STORE_URL) {
    url = process.env.APPLE_STORE_URL;
  }

  if (isAndroid && process.env.GOOGLE_STORE_URL) {
    url = process.env.GOOGLE_STORE_URL;
  }

  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return <p>Redirecting...</p>;
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale }: GetServerSidePropsContext) => {
    return {
      props: {
        layout: PageLayout.Private,
        ...(await serverSideTranslations(locale as string, ['layout'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default DownloadPage;
